import axios from 'axios';
import cookieManager from "@/managers/cookie.manager";
import api from "@/store/api/api";
import {locales, defaultLocale} from "@/config/locales.config";
import messageService from "../services/messageService";
import {extractFirstErrorMessage} from "../helpers/error";

const axiosInstance = axios.create({
    baseURL: api.root,
    headers: {
        'Content-Type': 'application/json',
    },
});

const errorLogger = error => {
    if (error?.response?.data?.type && error?.response?.data?.type === 'warning') {
        return Promise.reject(error);
    }
    messageService.error({
        content: extractFirstErrorMessage(error.response),
        duration: 4,
    });
    return Promise.reject(error);
};

axiosInstance.interceptors.request.use(
    (config) => {
        if (typeof window === 'undefined') return config;

        const urlLocale = window.location.href.split('/').at(3)

        config.headers.Authorization = `Bearer ${cookieManager.getItem('accessToken')}`;
        config.headers.Locale = locales.includes(urlLocale) ? urlLocale : defaultLocale;

        return config;
    },
    errorLogger
);

axiosInstance.interceptors.response.use(
    (response) => {
        return response.data.data;
    },
    errorLogger
);

export default axiosInstance;
